import { render, staticRenderFns } from "./worldBoss.vue?vue&type=template&id=4928209b&scoped=true&"
import script from "./worldBoss.vue?vue&type=script&lang=js&"
export * from "./worldBoss.vue?vue&type=script&lang=js&"
import style0 from "./worldBoss.vue?vue&type=style&index=0&id=4928209b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4928209b",
  null
  
)

export default component.exports